<template>
  <div class="error-container">
    <p
      role="alert"
      class="error-text"
      :style="{ ...getFontSizeForResponse('smallBodyText') }"
    >
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import fontSizeMixin from '@/mixins/fontSizeMixin'
export default {
  mixins: [fontSizeMixin],
  props: {
    errorMessage: String
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css/theme.scss';
.error-container {
  display: flex;
  flex: 1;
  .error-text {
    color: #b50000;
    margin: 5px 0;
  }
}
</style>
